import { colors } from "./designTokens";

export const RADAR_COMPETITOR_COLORS = [
  "#ef4444",
  "#22c55e",
  "#a855f7",
  "#f59e0b",
] as const;

export function getRadarSeriesColor(
  kind: "customer" | "competitor",
  competitorIndex = 0
): string {
  if (kind === "customer") return colors.primary;
  const index = ((competitorIndex % RADAR_COMPETITOR_COLORS.length) + RADAR_COMPETITOR_COLORS.length)
    % RADAR_COMPETITOR_COLORS.length;
  return RADAR_COMPETITOR_COLORS[index];
}
